import getPrefetchActions from './getPrefetchActions';
import prefetchWrapper from './prefetchWrapper';
/**
 * Creates a function for with binded application actions
 *
 * @param  {Object} actions — application actions
 * @return {Function} connectPrefetch
 */

export default function createConnectPrefetch(actions) {
  /**
   * Derocates component with prefetch functionality on componentDidMount
   * Requred options format:
   * — `array pathToActionCreator`
   * — function returning data in the same format
   *
   * @param  {Array|Function} options — options
   * @return {Object} — wrapped react component
   */
  return function connectPrefetch(options) {
    var prefetchActions = getPrefetchActions(options, actions);
    return prefetchWrapper(prefetchActions);
  };
}